import React from "react"
import styled from "styled-components"
import { up, down } from "styled-breakpoints"
import MaxWidthContainer, {
  Content,
} from "@components/Layout/MaxWidthContainer"
import MaxWidthContent from "@components/Layout/MaxWidthContent"

const StyledMaxWidthContainer = styled(MaxWidthContainer)`
  ${down("laptop")} {
    ${Content} {
      padding: 0;
    }
  }
`

const VideoFrame = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;

  @supports not (aspect-ratio: 16 / 9) {
    height: 0;
    padding-bottom: 56.25%;
  }
`

const IFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`

interface VideoProps {
  url: string
}

const Video: React.FC<VideoProps> = ({ url }) => {
  return (
    <StyledMaxWidthContainer>
      <MaxWidthContent cols={12}>
        <VideoFrame>
          <IFrame
            src={url}
            allow="autoplay; accelerometer; encrypted-media; fullscreen; gyroscope; picture-in-picture"
          />
        </VideoFrame>
      </MaxWidthContent>
    </StyledMaxWidthContainer>
  )
}

export default Video
